import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "scope", "source"];
import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import SuspensionBannersContext from '../contexts/suspensionBannersContext';
import useBanner from '../hooks/useBanner';
import scopePresent from '../util/scopePresent';
import Messaging from './Messaging';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SuspensionTooltip = _ref => {
  let {
      children,
      scope
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const hasStandardTooltipProps = Object.keys(props).length > 0;
  const scopeMissing = !scopePresent(scope);
  const {
    bannerInfo,
    bannerHiddenByUserFor
  } = useContext(SuspensionBannersContext);
  const {
    scopeDisabled,
    langPath,
    showCta,
    redirectUrl
  } = useBanner(bannerHiddenByUserFor(scope), bannerInfo(scope));
  const renderProps = {
    scopeDisabled,
    scopeMissing,
    disabled: scopeDisabled || scopeMissing
  };
  const suspensionTooltipChildren = typeof children === 'function' ? children(renderProps) : children;
  if (scopeDisabled) {
    // when scope is disabled, we present the suspension tooltip
    // that is controlled by this lib
    const sourceURL = window.location.href;
    return /*#__PURE__*/_jsx(Tooltip, Object.assign({}, props, {
      "aria-label": "account suspension tooltip",
      disabled: false,
      use: "longform",
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langPath.title
      }),
      title: /*#__PURE__*/_jsx(Messaging, {
        langPath: langPath,
        showCta: showCta,
        redirectUrl: redirectUrl,
        source: sourceURL
      }),
      children: suspensionTooltipChildren
    }));
  } else if (!scopeDisabled && hasStandardTooltipProps) {
    // when the scope isn't disabled but has props used by UITooltip,
    // we render the tooltip without any reference to suspensions
    return /*#__PURE__*/_jsx(Tooltip, Object.assign({}, props, {
      children: suspensionTooltipChildren
    }));
  } else {
    // at this point, we know there isn't a suspension, nor does an app
    // want to show a (fallback) tooltip; provide the children and
    // call it a day
    return /*#__PURE__*/_jsx(_Fragment, {
      children: suspensionTooltipChildren
    });
  }
};
export default SuspensionTooltip;